// extracted by mini-css-extract-plugin
export default {"container":"TruckDescriptionModule_container__stRwm","vinEditMessage":"TruckDescriptionModule_vinEditMessage__n+chP","row":"TruckDescriptionModule_row__Ce+Kj"};